import Select from "./src/select";

Select.install = function(Vue) {
  Vue.component(Select.name, Select);
};

export default Select;
